import { Component } from '@angular/core';

@Component({
  selector: 'app-platform-start',
  templateUrl: './platform-start.component.html',
  styleUrl: './platform-start.component.scss'
})
export class PlatformStartComponent {

}
